/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeGoCampaign_PrecinctGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Precinct Group Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, September 29, 2019 - 08:26:08 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      09/29/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const PRECINCTGROUP_LIST_CONTAINER_LOADED = 'PRECINCTGROUP_LIST_CONTAINER_LOADED';
export const PRECINCTGROUP_LIST_CONTAINER_UNLOADED = 'PRECINCTGROUP_LIST_CONTAINER_UNLOADED';
export const PRECINCTGROUP_LIST_TABLE_LOADED = 'PRECINCTGROUP_LIST_TABLE_LOADED';
export const PRECINCTGROUP_LIST_TABLE_UNLOADED = 'PRECINCTGROUP_LIST_TABLE_UNLOADED';

export const PRECINCTGROUP_LIST_CHANGE_GROUP = 'PRECINCTGROUP_LIST_CHANGE_GROUP';
export const PRECINCTGROUP_SELECT_ROW = 'PRECINCTGROUP_SELECT_ROW';

export const PRECINCTGROUP_ADD = 'PRECINCTGROUP_ADD';
export const PRECINCTGROUP_EDIT = 'PRECINCTGROUP_EDIT';
export const PRECINCTGROUP_DELETE = 'PRECINCTGROUP_DELETE';
export const PRECINCTGROUP_OPEN_WARNING = 'PRECINCTGROUP_OPEN_WARNING';
export const PRECINCTGROUP_CLOSE_WARNING = 'PRECINCTGROUP_CLOSE_WARNING';
export const PRECINCTGROUP_DELETE_DISABLE = 'PRECINCTGROUP_DELETE_DISABLE';
export const PRECINCTGROUP_VIEW_CHILD_ITEMS = 'PRECINCTGROUP_VIEW_CHILD_ITEMS';

export const PRECINCTGROUP_EDIT_CONTAINER_LOADED = 'PRECINCTGROUP_EDIT_CONTAINER_LOADED';
export const PRECINCTGROUP_EDIT_CONTAINER_UNLOADED = 'PRECINCTGROUP_EDIT_CONTAINER_UNLOADED';
export const PRECINCTGROUP_EDIT_FORM_LOADED = 'PRECINCTGROUP_EDIT_FORM_LOADED';
export const PRECINCTGROUP_EDIT_FORM_UNLOADED = 'PRECINCTGROUP_EDIT_FORM_UNLOADED';

export const PRECINCTGROUP_SET_GROUP_SELECT = 'PRECINCTGROUP_SET_GROUP_SELECT';
export const PRECINCTGROUP_EDIT_DATA_LOAD = 'PRECINCTGROUP_EDIT_DATA_LOAD';

export const PRECINCTGROUP_EDIT_CONTAINER_SUBMIT = 'PRECINCTGROUP_EDIT_CONTAINER_SUBMIT';
export const PRECINCTGROUP_EDIT_CONTAINER_CANCEL = 'PRECINCTGROUP_EDIT_CONTAINER_CANCEL';

export const PRECINCTGROUP_UPDATE_VALUE = 'PRECINCTGROUP_UPDATE_VALUE';


// WEBPACK FOOTER //
// ./src/constants/actionTypeGoCampaign_PrecinctGroups.js